// @generated
import { PapiDeviation } from '@wix/da-papi-types';

// IMPORTANT! Make sure to get those deviations from /dabrowse/faceted with
// expand = 'deviation.daily_devs' property
export const dailyDeviations: PapiDeviation[] = [
  {
    deviationId: 823890128,
    typeId: 1,
    url: 'https://www.deviantart.com/mariannainsomnia/art/Warrior-Fairy-823890128',
    title: 'Warrior Fairy',
    isJournal: false,
    isPurchasable: true,
    publishedTime: '2019-12-18T00:07:59-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 12989578,
      useridUuid: '49b0c7bf-ed11-463e-a472-72c571a853b8',
      username: 'MariannaInsomnia',
      usericon: 'https://a.deviantart.net/avatars-big/m/a/mariannainsomnia.jpg?3',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 15,
      favourites: 330,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/49b0c7bf-ed11-463e-a472-72c571a853b8/ddmitow-21497a45-4c21-4d89-b8fb-3362c8894df1.jpg',
      prettyName: 'warrior_fairy_by_mariannainsomnia_ddmitow',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjczIiwicGF0aCI6IlwvZlwvNDliMGM3YmYtZWQxMS00NjNlLWE0NzItNzJjNTcxYTg1M2I4XC9kZG1pdG93LTIxNDk3YTQ1LTRjMjEtNGQ4OS1iOGZiLTMzNjJjODg5NGRmMS5qcGciLCJ3aWR0aCI6Ijw9OTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.gBYaZcXFsm773A3wbRXdGlSM7gRvP3M2JS7ZxX53wZU',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 112,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_268,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 267,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_673,q_70,strp/<prettyName>-300w.jpg',
          h: 224,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_334,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 334,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_468,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 468,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_535,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 535,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_900,h_673,q_75,strp/<prettyName>-fullview.jpg',
          h: 673,
          w: 900,
          f: 8749071,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_900,h_673,q_75,strp/<prettyName>-fullview.jpg',
          h: 673,
          w: 900,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_900,h_673,q_75,strp/<prettyName>-fullview.jpg',
          h: 673,
          w: 900,
          f: 8749071,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/823890128/">Warrior Fairy</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/mariannainsomnia" target="_self">MariannaInsomnia</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 4837142,
        useridUuid: '7adc5a6c-2e61-4e55-8f33-fabe92a17312',
        username: 'pullingcandy',
        usericon: 'https://a.deviantart.net/avatars-big/p/u/pullingcandy.jpg',
        type: 'volunteer',
        isNewDeviant: false,
      },
      suggester: {
        userId: 43502155,
        useridUuid: 'd6090b4f-7c79-4f51-adfd-c1a53992a2cf',
        username: 'Daisy-Flauriossa',
        usericon: 'https://a.deviantart.net/avatars-big/d/a/daisy-flauriossa.jpg?6',
        type: 'regular',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 821632832,
    typeId: 1,
    url: 'https://www.deviantart.com/recalibration/art/Togawano-Kiba-821632832',
    title: 'Togawano Kiba',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-11-27T07:46:48-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 13398747,
      useridUuid: 'bbc29bde-3721-4eb0-ac01-a16f2af12b50',
      username: 'Recalibration',
      usericon: 'https://a.deviantart.net/avatars-big/r/e/recalibration.jpg?9',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 32,
      favourites: 198,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/bbc29bde-3721-4eb0-ac01-a16f2af12b50/ddl6fy8-d11aa64b-fe1e-42d1-91fe-a65ba0be1a78.jpg',
      prettyName: 'togawano_kiba_by_recalibration_ddl6fy8',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTM1MCIsInBhdGgiOiJcL2ZcL2JiYzI5YmRlLTM3MjEtNGViMC1hYzAxLWExNmYyYWYxMmI1MFwvZGRsNmZ5OC1kMTFhYTY0Yi1mZTFlLTQyZDEtOTFmZS1hNjViYTBiZTFhNzguanBnIiwid2lkdGgiOiI8PTkwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.96knDpfbUcRlh5nzHQ6hY52uzBOIvPpSGn4G06XllMc',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 100,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/crop/w_133,h_200,x_0,y_0,scl_0.10105580693816,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 133,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 450,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_167,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 167,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/crop/w_233,h_350,x_0,y_0,scl_0.17647058823529,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 233,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_267,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 267,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_730,h_1095,q_70,strp/<prettyName>-pre.jpg',
          h: 1095,
          w: 730,
          f: 1953280,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_730,h_1095,q_70,strp/<prettyName>-pre.jpg',
          h: 1095,
          w: 730,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_900,h_1350,q_75,strp/<prettyName>-fullview.jpg',
          h: 1350,
          w: 900,
          f: 1953280,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/821632832/">Togawano Kiba</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/recalibration" target="_self">Recalibration</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 1020294,
        useridUuid: '567905cc-8ba0-42d4-af01-054697b8fab6',
        username: 'JenFruzz',
        usericon: 'https://a.deviantart.net/avatars-big/j/e/jenfruzz.gif?6',
        type: 'volunteer',
        isNewDeviant: false,
      },
      suggester: {
        userId: 1076934,
        useridUuid: '0f5836b4-5491-41af-89c8-a10ea59b69ce',
        username: 'pulbern',
        usericon: 'https://a.deviantart.net/avatars-big/p/u/pulbern.gif?6',
        type: 'senior',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 797056503,
    typeId: 1,
    url: 'https://www.deviantart.com/licataknives/art/blade-with-horn-797056503',
    title: 'blade with horn',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-05-09T14:30:02-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 18978937,
      useridUuid: 'bd38dd60-280e-4e58-b939-d2b1ec755482',
      username: 'Licataknives',
      usericon: 'https://a.deviantart.net/avatars-big/l/i/licataknives.jpg?4',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 2,
      favourites: 27,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/bd38dd60-280e-4e58-b939-d2b1ec755482/dd6joqf-474082ec-8a91-4e5d-b86b-d0a296911077.jpg',
      prettyName: 'blade_with_horn_by_licataknives_dd6joqf',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTQwIiwicGF0aCI6IlwvZlwvYmQzOGRkNjAtMjgwZS00ZTU4LWI5MzktZDJiMWVjNzU1NDgyXC9kZDZqb3FmLTQ3NDA4MmVjLThhOTEtNGU1ZC1iODZiLWQwYTI5NjkxMTA3Ny5qcGciLCJ3aWR0aCI6Ijw9OTYwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.NtIkXkRoDJ1m59nXPp-RJ3lLGZuaeuoPnS_SZ7u65Hk',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2JkMzhkZDYwLTI4MGUtNGU1OC1iOTM5LWQyYjFlYzc1NTQ4MlwvZGQ2am9xZi00NzQwODJlYy04YTkxLTRlNWQtYjg2Yi1kMGEyOTY5MTEwNzcuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.jUzXg7xNEez_voJq1oyqzidSQRLXZewihAiVWwUActQ',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_540,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_960,h_540,q_75,strp/<prettyName>-fullview.jpg',
          h: 540,
          w: 960,
          f: 198814,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_960,h_540,q_75,strp/<prettyName>-fullview.jpg',
          h: 540,
          w: 960,
        },
        {
          t: 'fullview',
          r: 1,
          h: 540,
          w: 960,
          f: 198814,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/797056503/">blade with horn</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/licataknives" target="_self">Licataknives</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 6324307,
        useridUuid: 'e3514b60-d214-4b75-9cdd-c328cf93abeb',
        username: 'SinistrosePhosphate',
        usericon: 'https://a.deviantart.net/avatars-big/s/i/sinistrosephosphate.gif?5',
        type: 'volunteer',
        isNewDeviant: false,
      },
      suggester: {
        userId: 36634274,
        useridUuid: '3d565081-7ad3-49b3-a61d-5734e1e1bc4d',
        username: 'craftsbyblue',
        usericon: 'https://a.deviantart.net/avatars-big/c/r/craftsbyblue.jpg?6',
        type: 'beta',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 821910890,
    typeId: 1,
    url: 'https://www.deviantart.com/cryptid-creations/art/Ottumn-Patreon-HQ-Wallpaper-821910890',
    title: 'Ottumn - Patreon HQ Wallpaper',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-11-30T08:00:26-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 8681647,
      useridUuid: '885a6dec-35b8-456f-a409-43b214729c22',
      username: 'Cryptid-Creations',
      usericon: 'https://a.deviantart.net/avatars-big/c/r/cryptid-creations.png?4',
      type: 'senior',
      isNewDeviant: false,
    },
    stats: {
      comments: 35,
      favourites: 2279,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/885a6dec-35b8-456f-a409-43b214729c22/ddlcei2-81ba6f57-49b0-4c87-904c-5d981c3ec5af.png',
      prettyName: 'ottumn___patreon_hq_wallpaper_by_cryptid_creations_ddlcei2',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTQ1IiwicGF0aCI6IlwvZlwvODg1YTZkZWMtMzViOC00NTZmLWE0MDktNDNiMjE0NzI5YzIyXC9kZGxjZWkyLTgxYmE2ZjU3LTQ5YjAtNGM4Ny05MDRjLTVkOTgxYzNlYzVhZi5wbmciLCJ3aWR0aCI6Ijw9MTAwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.rRN1LyPxg10s2ZotdmkSzForqXvLH9_IVentmnMGYQ8',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzg4NWE2ZGVjLTM1YjgtNDU2Zi1hNDA5LTQzYjIxNDcyOWMyMlwvZGRsY2VpMi04MWJhNmY1Ny00OWIwLTRjODctOTA0Yy01ZDk4MWMzZWM1YWYucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.LQGIL-6WRzVLAD2wIt7-HXmJhTP35I2Vu1on9UBrnuY',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 82,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_164,q_70,strp/<prettyName>-200h.jpg',
          h: 164,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_545,q_70,strp/<prettyName>-300w.jpg',
          h: 164,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_459,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 459,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_642,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 642,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_734,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 734,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1000,h_545,q_80,strp/<prettyName>-fullview.jpg',
          h: 545,
          w: 1000,
          f: 844483,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1000,h_545,q_80,strp/<prettyName>-fullview.jpg',
          h: 545,
          w: 1000,
        },
        {
          t: 'fullview',
          r: 1,
          h: 545,
          w: 1000,
          f: 844483,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/821910890/">Ottumn - Patreon HQ Wallpaper</a> by <span class="username-with-symbol u"><a class="u senior username" href="https://www.deviantart.com/cryptid-creations" target="_self">Cryptid-Creations</a><span class="user-symbol senior" data-quicktip-text="Senior Member" data-show-tooltip="1" data-gruser-type="senior"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 22533787,
        useridUuid: 'faa48d2d-12c2-43d1-bf23-b5e99857825b',
        username: 'Ellysiumn',
        usericon: 'https://a.deviantart.net/avatars-big/e/l/ellysiumn.png?8',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 825075607,
    typeId: 1,
    url: 'https://www.deviantart.com/heliocyan/art/Two-Toed-Sloth-and-her-baby-825075607',
    title: 'Two Toed Sloth and her baby',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-12-29T06:51:50-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 11067498,
      useridUuid: '58b54e75-1f3e-4e37-ad30-871bb1acf246',
      username: 'Heliocyan',
      usericon: 'https://a.deviantart.net/avatars-big/h/e/heliocyan.jpg?7',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 14,
      favourites: 148,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/58b54e75-1f3e-4e37-ad30-871bb1acf246/ddn88ev-2079e972-bac7-4e59-ba17-6296606deb51.jpg',
      prettyName: 'two_toed_sloth_and_her_baby_by_heliocyan_ddn88ev',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTkyIiwicGF0aCI6IlwvZlwvNThiNTRlNzUtMWYzZS00ZTM3LWFkMzAtODcxYmIxYWNmMjQ2XC9kZG44OGV2LTIwNzllOTcyLWJhYzctNGU1OS1iYTE3LTYyOTY2MDZkZWI1MS5qcGciLCJ3aWR0aCI6Ijw9NzAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.lu166z_DPtF9EDWQ3-wVq3_dEN755UTGgGWRifX6GX4',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzU4YjU0ZTc1LTFmM2UtNGUzNy1hZDMwLTg3MWJiMWFjZjI0NlwvZGRuODhldi0yMDc5ZTk3Mi1iYWM3LTRlNTktYmExNy02Mjk2NjA2ZGViNTEuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.Ro9OCVIaMKeVWjWXwhhVR2pQzj1rw4y1xhN_211WGog',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 106,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_141,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 141,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 425,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/crop/w_176,h_250,x_0,y_0,scl_0.25285714285714,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 176,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_247,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 247,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_282,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 282,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_700,h_992,q_75,strp/<prettyName>-fullview.jpg',
          h: 992,
          w: 700,
          f: 426194,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_700,h_992,q_75,strp/<prettyName>-fullview.jpg',
          h: 992,
          w: 700,
        },
        {
          t: 'fullview',
          r: 1,
          h: 992,
          w: 700,
          f: 426194,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/825075607/">Two Toed Sloth and her baby</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/heliocyan" target="_self">Heliocyan</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 10996160,
        useridUuid: 'cc2827f3-4bf0-4346-8d53-ebd6c88ba667',
        username: 'TokyoMoonlight',
        usericon: 'https://a.deviantart.net/avatars-big/t/o/tokyomoonlight.jpg?2',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 823910726,
    typeId: 1,
    url: 'https://www.deviantart.com/blondynkitezgraja/art/Death-Knight-823910726',
    title: 'Death Knight',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-12-18T07:28:41-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 32793959,
      useridUuid: '02721cb8-957d-4bae-b950-11016461189b',
      username: 'BlondynkiTezGraja',
      usericon: 'https://a.deviantart.net/avatars-big/b/l/blondynkitezgraja.jpg?5',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 5,
      favourites: 540,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/02721cb8-957d-4bae-b950-11016461189b/ddmj9l2-8bb243ce-b63d-4924-95fb-991277cf9154.jpg',
      prettyName: 'death_knight_by_blondynkitezgraja_ddmj9l2',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzI0IiwicGF0aCI6IlwvZlwvMDI3MjFjYjgtOTU3ZC00YmFlLWI5NTAtMTEwMTY0NjExODliXC9kZG1qOWwyLThiYjI0M2NlLWI2M2QtNDkyNC05NWZiLTk5MTI3N2NmOTE1NC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.BQQ9-fR-_WrJmsnduJHrKGscPUoQM-xgbk0q5HtdvmU',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 106,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_283,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 283,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_724,q_70,strp/<prettyName>-300w.jpg',
          h: 212,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_354,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 354,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_495,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 495,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_566,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 566,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1024,h_724,q_75,strp/<prettyName>-fullview.jpg',
          h: 724,
          w: 1024,
          f: 9122740,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1024,h_724,q_75,strp/<prettyName>-fullview.jpg',
          h: 724,
          w: 1024,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1024,h_724,q_75,strp/<prettyName>-fullview.jpg',
          h: 724,
          w: 1024,
          f: 9122740,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/823910726/">Death Knight</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/blondynkitezgraja" target="_self">BlondynkiTezGraja</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 14113432,
        useridUuid: '209fee51-2b61-425a-9d6e-069bd1b9a1e5',
        username: 'RezaBisuto',
        usericon: 'https://a.deviantart.net/avatars-big/r/e/rezabisuto.jpg?12',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 815487444,
    typeId: 1,
    url: 'https://www.deviantart.com/afterthenonsequitur/art/Ancient-History-815487444',
    title: 'Ancient History',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-10-03T15:17:51-0700',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/815487444',
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 6145267,
      useridUuid: '0ee45426-8fbf-4c32-b376-50a33ecc669f',
      username: 'AfterTheNonSequitur',
      usericon: 'https://a.deviantart.net/avatars-big/a/f/afterthenonsequitur.gif?7',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 6,
      favourites: 24,
    },
    media: {
      types: [
        {
          t: 'preview',
          r: -2,
          s: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          h: 220,
          w: 500,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/815487444/">Ancient History</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/afterthenonsequitur" target="_self">AfterTheNonSequitur</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 2411877,
        useridUuid: 'f4fa095f-d42e-4e2e-9ac0-1488368209c9',
        username: 'SingingFlames',
        usericon: 'https://a.deviantart.net/avatars-big/s/i/singingflames.png?6',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
    textContent: {
      excerpt:
        "Demeter drives us through Greece,\nAlong a coastline scattered with ruin old and new,\nMy skin smells of salt and sun and the sea.\n\nStill one of the kore, not yet Persephone,\nI haven't eaten of those seeds,\nThough I tell him: let me, let me, let me\nBut Hades lives near Helsinki,\nA colder coastline, icy and distant,\nAnd when did Hades have to be convinced of Persephone?\nDid she chase after him,\nto put her heart in his hand?\n\nI am sinking.\nI am close, always, but so far, so far.\nAthens and Helsinki,\nWinter and spring.\nI go away with my hands filled with centuries,\nEmpty of you.",
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 826000637,
    typeId: 1,
    url: 'https://www.deviantart.com/wreckham/art/Remember-Who-You-Are-826000637',
    title: 'Remember Who You Are',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-05T19:38:46-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 12529924,
      useridUuid: '9be339cb-fd80-47fd-8cb8-6052989ee6e4',
      username: 'Wreckham',
      usericon: 'https://a.deviantart.net/avatars-big/w/r/wreckham.png?6',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 11,
      favourites: 164,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/9be339cb-fd80-47fd-8cb8-6052989ee6e4/ddns265-eeaf3710-b170-4186-b70b-7f3c0043ac50.png',
      prettyName: 'remember_who_you_are_by_wreckham_ddns265',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTY5NCIsInBhdGgiOiJcL2ZcLzliZTMzOWNiLWZkODAtNDdmZC04Y2I4LTYwNTI5ODllZTZlNFwvZGRuczI2NS1lZWFmMzcxMC1iMTcwLTQxODYtYjcwYi03ZjNjMDA0M2FjNTAucG5nIiwid2lkdGgiOiI8PTEyODAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.fF6AlwNZyKC5UaRAdykzmwV5XedL2DrgFhvCL5ZSnBU',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 113,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_151,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 151,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 397,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_189,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 189,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/crop/w_265,h_350,x_0,y_0,scl_0.106,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 264,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/crop/w_302,h_400,x_0,y_0,scl_0.1212,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 302,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_777,h_1028,q_70,strp/<prettyName>-pre.jpg',
          h: 1028,
          w: 777,
          f: 17304692,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_777,h_1028,q_70,strp/<prettyName>-pre.jpg',
          h: 1028,
          w: 777,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1280,h_1694,q_80,strp/<prettyName>-fullview.jpg',
          h: 1694,
          w: 1280,
          f: 17304692,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/826000637/">Remember Who You Are</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/wreckham" target="_self">Wreckham</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 1733358,
        useridUuid: 'eb30bc25-5eec-499a-bb0b-590b7354ef70',
        username: 'Thiefoworld',
        usericon: 'https://a.deviantart.net/avatars-big/t/h/thiefoworld.gif',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 825992647,
    typeId: 1,
    url: 'https://www.deviantart.com/yoshiyaki/art/Koopa-Beach-Mario-Kart-64-Fanart-825992647',
    title: 'Koopa Beach - Mario Kart 64 Fanart',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-05T18:15:16-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 7871534,
      useridUuid: 'a1e60c31-71aa-4e7d-a61c-a6a512583c25',
      username: 'yoshiyaki',
      usericon: 'https://a.deviantart.net/avatars-big/y/o/yoshiyaki.jpg?8',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 77,
      favourites: 1699,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/a1e60c31-71aa-4e7d-a61c-a6a512583c25/ddnrw07-270d2b6b-2d55-4d05-8f5c-99e5365b97f8.jpg',
      prettyName: 'koopa_beach___mario_kart_64_fanart_by_yoshiyaki_ddnrw07',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTIwMCIsInBhdGgiOiJcL2ZcL2ExZTYwYzMxLTcxYWEtNGU3ZC1hNjFjLWE2YTUxMjU4M2MyNVwvZGRucncwNy0yNzBkMmI2Yi0yZDU1LTRkMDUtOGY1Yy05OWU1MzY1Yjk3ZjguanBnIiwid2lkdGgiOiI8PTg5OCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.Xw8O9gvgDcbUhDQEhBQR2AgsALfhDof4myZU9Eq1a44',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2ExZTYwYzMxLTcxYWEtNGU3ZC1hNjFjLWE2YTUxMjU4M2MyNVwvZGRucncwNy0yNzBkMmI2Yi0yZDU1LTRkMDUtOGY1Yy05OWU1MzY1Yjk3ZjguanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.QwSxEDQsjqyuncYlZdrmb4u_v4ENxlI_E69X0CKYlBQ',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 112,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_150,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 150,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 401,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_187,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 187,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_262,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 262,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_299,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 299,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_773,h_1033,q_70,strp/<prettyName>-pre.jpg',
          h: 1033,
          w: 773,
          f: 479850,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_773,h_1033,q_70,strp/<prettyName>-pre.jpg',
          h: 1033,
          w: 773,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1200,
          w: 898,
          f: 479850,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/825992647/">Koopa Beach - Mario Kart 64 Fanart</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/yoshiyaki" target="_self">yoshiyaki</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 713265,
        useridUuid: 'd125df43-37f9-4450-a601-50d3aa7fa501',
        username: 'TsaoShin',
        usericon: 'https://a.deviantart.net/avatars-big/t/s/tsaoshin.gif?3',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 825958518,
    typeId: 1,
    url: 'https://www.deviantart.com/ntdespoina/art/Unrequited-love-825958518',
    title: 'Unrequited love',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-05T13:07:22-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 18281641,
      useridUuid: '4e118e19-15d6-4370-8654-20f6c74e7b08',
      username: 'ntdespoina',
      usericon: 'https://a.deviantart.net/avatars-big/n/t/ntdespoina.jpg?12',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 1,
      favourites: 33,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/4e118e19-15d6-4370-8654-20f6c74e7b08/ddnr5o6-432e3702-3e10-44e8-9a81-df6735d67186.jpg',
      prettyName: 'unrequited_love_by_ntdespoina_ddnr5o6',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTEzMiIsInBhdGgiOiJcL2ZcLzRlMTE4ZTE5LTE1ZDYtNDM3MC04NjU0LTIwZjZjNzRlN2IwOFwvZGRucjVvNi00MzJlMzcwMi0zZTEwLTQ0ZTgtOWE4MS1kZjY3MzVkNjcxODYuanBnIiwid2lkdGgiOiI8PTgwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.JVol0Wn8QWuXeVQT2la3HX8f1Hqkwq0SXM_uf7Mzptk',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 106,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/crop/w_141,h_200,x_0,y_0,scl_0.057258064516129,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 141,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 425,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_177,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 177,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/crop/w_247,h_350,x_0,y_0,scl_0.1,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 247,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_283,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 283,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_751,h_1063,q_70,strp/<prettyName>-pre.jpg',
          h: 1063,
          w: 751,
          f: 2402572,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_751,h_1063,q_70,strp/<prettyName>-pre.jpg',
          h: 1063,
          w: 751,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_800,h_1132,q_75,strp/<prettyName>-fullview.jpg',
          h: 1132,
          w: 800,
          f: 2402572,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/825958518/">Unrequited love</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/ntdespoina" target="_self">ntdespoina</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 541228,
        useridUuid: '5595eaf4-9d27-44b9-a2e9-3c113acd9049',
        username: 'Moonbeam13',
        usericon: 'https://a.deviantart.net/avatars-big/m/o/moonbeam13.gif?5',
        type: 'admin',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 797388116,
    typeId: 1,
    url: 'https://www.deviantart.com/chazillah/art/The-Wheel-weaves-as-the-Wheel-wills-797388116',
    title: 'The Wheel weaves as the Wheel wills',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-05-12T08:30:05-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 5965097,
      useridUuid: '62403b3b-32d1-46e9-b493-755a434eba1b',
      username: 'chazillah',
      usericon: 'https://a.deviantart.net/avatars-big/c/h/chazillah.gif?7',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 24,
      favourites: 458,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/62403b3b-32d1-46e9-b493-755a434eba1b/dd6qslw-3a56fab0-f9a8-4c6c-8794-772196b10f9d.jpg',
      prettyName: 'the_wheel_weaves_as_the_wheel_wills_by_chazillah_dd6qslw',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTU4NSIsInBhdGgiOiJcL2ZcLzYyNDAzYjNiLTMyZDEtNDZlOS1iNDkzLTc1NWE0MzRlYmExYlwvZGQ2cXNsdy0zYTU2ZmFiMC1mOWE4LTRjNmMtODc5NC03NzIxOTZiMTBmOWQuanBnIiwid2lkdGgiOiI8PTEyODAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.wbKgZrkp6e2o5tCCWSoeMN_wqoKjrCJTFA8QwXXe6Hc',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 121,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/crop/w_162,h_200,x_0,y_0,scl_0.085941644562334,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 162,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 371,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_202,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 202,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_283,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 283,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_323,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 323,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_803,h_995,q_70,strp/<prettyName>-pre.jpg',
          h: 995,
          w: 803,
          f: 1846337,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_803,h_995,q_70,strp/<prettyName>-pre.jpg',
          h: 995,
          w: 803,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1280,h_1585,q_75,strp/<prettyName>-fullview.jpg',
          h: 1585,
          w: 1280,
          f: 1846337,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/797388116/">The Wheel weaves as the Wheel wills</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/chazillah" target="_self">chazillah</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 27220785,
        useridUuid: '5417d554-dc0f-4b19-ab80-c42562d36a72',
        username: 'lovelessdevotions',
        usericon: 'https://a.deviantart.net/avatars-big/l/o/lovelessdevotions.gif?6',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 818929931,
    typeId: 1,
    url: 'https://www.deviantart.com/kuri-nyann/art/Video-Fanart-Frozen-II-818929931',
    title: '(+Video) Fanart - Frozen II',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-11-02T07:01:39-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 30139174,
      useridUuid: '7aa782f3-fc67-4ab0-9f19-c8a763be2b9a',
      username: 'Kuri-Nyann',
      usericon: 'https://a.deviantart.net/avatars-big/k/u/kuri-nyann.png?3',
      type: 'beta',
      isNewDeviant: false,
    },
    stats: {
      comments: 13,
      favourites: 338,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/7aa782f3-fc67-4ab0-9f19-c8a763be2b9a/ddjkidn-865cbfc6-64cc-45ec-9a22-763659b8eefa.png',
      prettyName: '__video__fanart___frozen_ii_by_kuri_nyann_ddjkidn',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODU2IiwicGF0aCI6IlwvZlwvN2FhNzgyZjMtZmM2Ny00YWIwLTlmMTktYzhhNzYzYmUyYjlhXC9kZGpraWRuLTg2NWNiZmM2LTY0Y2MtNDVlYy05YTIyLTc2MzY1OWI4ZWVmYS5wbmciLCJ3aWR0aCI6Ijw9MTUyOCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.30muEARpcE9CHEt55m5AvgZRP3Qd4N-efHkYauRvWWQ',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzdhYTc4MmYzLWZjNjctNGFiMC05ZjE5LWM4YTc2M2JlMmI5YVwvZGRqa2lkbi04NjVjYmZjNi02NGNjLTQ1ZWMtOWEyMi03NjM2NTliOGVlZmEucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.BSVnw-C1xgdp_NtmdVLY8pCNNHEkv7_ihKoWT_gC0_U',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
          h: 84,
          w: 150,
          o: true,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_168,strp/<prettyName>-200h.png',
          h: 168,
          w: 300,
          o: true,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_856,strp/<prettyName>-300w.png',
          h: 168,
          w: 300,
          o: true,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_446,h_250,strp/<prettyName>-250t.png',
          h: 250,
          w: 446,
          o: true,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_625,h_350,strp/<prettyName>-350t.png',
          h: 350,
          w: 625,
          o: true,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_714,h_400,strp/<prettyName>-400t.png',
          h: 400,
          w: 714,
          o: true,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1195,h_669,strp/<prettyName>-pre.png',
          h: 669,
          w: 1195,
          o: true,
          f: 1859834,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1195,h_669,strp/<prettyName>-pre.png',
          h: 669,
          w: 1195,
          o: true,
        },
        {
          t: 'fullview',
          r: 1,
          h: 856,
          w: 1528,
          o: true,
          f: 1859834,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/818929931/">(+Video) Fanart - Frozen II</a> by <span class="username-with-symbol u"><a class="u beta username" href="https://www.deviantart.com/kuri-nyann" target="_self">Kuri-Nyann</a><span class="user-symbol beta" data-quicktip-text="Beta Tester" data-show-tooltip="1" data-gruser-type="beta"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 16294182,
        useridUuid: '328fe1e6-c25e-4190-9946-7fa65f0bc65d',
        username: 'Astralseed',
        usericon: 'https://a.deviantart.net/avatars-big/a/s/astralseed.gif?3',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 819265902,
    typeId: 1,
    url: 'https://www.deviantart.com/karim-91/art/Master-Classes-2019-don-t-make-a-cow-angry-819265902',
    title: "[Master Classes]2019_don't make a cow angry",
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-11-05T06:46:31-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 34996051,
      useridUuid: '4b1d32dd-fd6c-4528-9fa2-b0355b420980',
      username: 'Karim-91',
      usericon: 'https://a.deviantart.net/avatars-big/k/a/karim-91.gif?4',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 10,
      favourites: 44,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/4b1d32dd-fd6c-4528-9fa2-b0355b420980/ddjrpm6-0abe9312-7196-4b98-b02d-5d1639fb2cba.jpg',
      prettyName: '_master_classes_2019_don_t_make_a_cow_angry_by_karim_91_ddjrpm6',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTA2IiwicGF0aCI6IlwvZlwvNGIxZDMyZGQtZmQ2Yy00NTI4LTlmYTItYjAzNTViNDIwOTgwXC9kZGpycG02LTBhYmU5MzEyLTcxOTYtNGI5OC1iMDJkLTVkMTYzOWZiMmNiYS5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.cZ6HzbuBHR4-XqYywkYVNj6-z8GQdQjT0G9qxq9Rzxs',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 106,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_283,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 283,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 212,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_353,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 353,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_495,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 494,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_566,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 565,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1063,h_752,q_70,strp/<prettyName>-pre.jpg',
          h: 752,
          w: 1063,
          f: 265603,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1063,h_752,q_70,strp/<prettyName>-pre.jpg',
          h: 752,
          w: 1063,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1280,h_906,q_75,strp/<prettyName>-fullview.jpg',
          h: 906,
          w: 1280,
          f: 265603,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/819265902/">[Master Classes]2019_don\'t make a cow angry</a> by <span class="username-with-symbol u"><a class="u premium username" href="https://www.deviantart.com/karim-91" target="_self">Karim-91</a><span class="user-symbol premium" data-quicktip-text="Core Member" data-show-tooltip="1" data-gruser-type="premium"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 11880634,
        useridUuid: '709aedd4-65c1-424f-84e3-aad0bad1e224',
        username: 'TheGalleryOfEve',
        usericon: 'https://a.deviantart.net/avatars-big/t/h/thegalleryofeve.gif?1',
        type: 'volunteer',
        isNewDeviant: false,
      },
      suggester: {
        userId: 4785986,
        useridUuid: 'd28cf83f-80c6-4293-86b3-93c220cb8117',
        username: 'Miss-Phantomy',
        usericon: 'https://a.deviantart.net/avatars-big/m/i/miss-phantomy.png?8',
        type: 'regular',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 823254440,
    typeId: 1,
    url: 'https://www.deviantart.com/wbyrd/art/Fynrii-Class-Heavy-Combat-Frame-823254440',
    title: 'Fynrii Class Heavy Combat Frame',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-12-12T02:07:06-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 18905993,
      useridUuid: '98511e3c-0d59-4e12-9a16-4bc57c1677a5',
      username: 'wbyrd',
      usericon: 'https://a.deviantart.net/avatars-big/w/b/wbyrd.png?4',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 8,
      favourites: 79,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/98511e3c-0d59-4e12-9a16-4bc57c1677a5/ddm576w-086cd34d-fe10-4a62-a9ab-da97de18d385.png',
      prettyName: 'fynrii_class_heavy_combat_frame_by_wbyrd_ddm576w',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTI2IiwicGF0aCI6IlwvZlwvOTg1MTFlM2MtMGQ1OS00ZTEyLTlhMTYtNGJjNTdjMTY3N2E1XC9kZG01NzZ3LTA4NmNkMzRkLWZlMTAtNGE2Mi1hOWFiLWRhOTdkZTE4ZDM4NS5wbmciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.S5x6BPSCUMDXVBluYRhOVulrLql0dQVRAplfnWaeFm8',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 136,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_221,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 221,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 271,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_277,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 276,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_387,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 387,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_442,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 442,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_940,h_850,q_70,strp/<prettyName>-pre.jpg',
          h: 850,
          w: 940,
          f: 1998070,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_940,h_850,q_70,strp/<prettyName>-pre.jpg',
          h: 850,
          w: 940,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1024,h_926,q_80,strp/<prettyName>-fullview.jpg',
          h: 926,
          w: 1024,
          f: 1998070,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/823254440/">Fynrii Class Heavy Combat Frame</a> by <span class="username-with-symbol u"><a class="u premium username" href="https://www.deviantart.com/wbyrd" target="_self">wbyrd</a><span class="user-symbol premium" data-quicktip-text="Core Member" data-show-tooltip="1" data-gruser-type="premium"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 5165001,
        useridUuid: 'aebd39d1-db07-4db5-8b83-8771baa355ab',
        username: 'DasGnomo',
        usericon: 'https://a.deviantart.net/avatars-big/d/a/dasgnomo.gif?8',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 816145183,
    typeId: 1,
    url: 'https://www.deviantart.com/galoogamelady/art/TSDK-Page-17-816145183',
    title: 'TSDK - Page 17',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-10-13T08:10:52-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 7263088,
      useridUuid: 'bad21da3-d49a-4747-a54e-0ca5174bcc84',
      username: 'GalooGameLady',
      usericon: 'https://a.deviantart.net/avatars-big/g/a/galoogamelady.png?13',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 17,
      favourites: 176,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/bad21da3-d49a-4747-a54e-0ca5174bcc84/ddhwtnj-98341986-ef8f-495c-bddf-fb05c089fabd.png',
      prettyName: 'tsdk___page_17_by_galoogamelady_ddhwtnj',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTU1NiIsInBhdGgiOiJcL2ZcL2JhZDIxZGEzLWQ0OWEtNDc0Ny1hNTRlLTBjYTUxNzRiY2M4NFwvZGRod3Ruai05ODM0MTk4Ni1lZjhmLTQ5NWMtYmRkZi1mYjA1YzA4OWZhYmQucG5nIiwid2lkdGgiOiI8PTEwMDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.ioJ8SvfjN2Evb4HTpwKq2QcDDXrxPIkqcKvqYa1pUe8',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2JhZDIxZGEzLWQ0OWEtNDc0Ny1hNTRlLTBjYTUxNzRiY2M4NFwvZGRod3Ruai05ODM0MTk4Ni1lZjhmLTQ5NWMtYmRkZi1mYjA1YzA4OWZhYmQucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.Fj-FkU5KrfbNND30uiKy24oqjYTMqeTkVqg6tsnkN_4',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 96,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/crop/w_129,h_200,x_0,y_0,scl_0.129,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 129,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 467,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/crop/w_161,h_250,x_0,y_0,scl_0.161,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 161,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_225,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 225,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_257,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 257,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_717,h_1115,q_70,strp/<prettyName>-pre.jpg',
          h: 1115,
          w: 717,
          f: 1849219,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_717,h_1115,q_70,strp/<prettyName>-pre.jpg',
          h: 1115,
          w: 717,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1556,
          w: 1000,
          f: 1849219,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/816145183/">TSDK - Page 17</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/galoogamelady" target="_self">GalooGameLady</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-07T00:00:00-0800',
      giver: {
        userId: 464358,
        useridUuid: '08a7bba5-5ddf-4be3-85f7-ffd1b0f11d7f',
        username: 'DrZime',
        usericon: 'https://a.deviantart.net/avatars-big/d/r/drzime.png?9',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 823485607,
    typeId: 1,
    url: 'https://www.deviantart.com/katiehofgard/art/KittenBee-in-Autumn-823485607',
    title: 'KittenBee in Autumn',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-12-14T07:52:45-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 396046,
      useridUuid: '0b1aaf14-adfd-4c20-985f-05f6ade4afc3',
      username: 'KatieHofgard',
      usericon: 'https://a.deviantart.net/avatars-big/k/a/katiehofgard.gif?13',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 105,
      favourites: 3308,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0b1aaf14-adfd-4c20-985f-05f6ade4afc3/ddma5k7-4643b9b7-40c7-4b8b-a8af-5f6a2b6daf84.png',
      prettyName: 'kittenbee_in_autumn_by_katiehofgard_ddma5k7',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODgwIiwicGF0aCI6IlwvZlwvMGIxYWFmMTQtYWRmZC00YzIwLTk4NWYtMDVmNmFkZTRhZmMzXC9kZG1hNWs3LTQ2NDNiOWI3LTQwYzctNGI4Yi1hOGFmLTVmNmEyYjZkYWY4NC5wbmciLCJ3aWR0aCI6Ijw9MTEyMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.hNLrPm6VWa2jd3_QRsuWsC1FT8iGTL6Y3PLtBzQjBXE',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzBiMWFhZjE0LWFkZmQtNGMyMC05ODVmLTA1ZjZhZGU0YWZjM1wvZGRtYTVrNy00NjQzYjliNy00MGM3LTRiOGItYThhZi01ZjZhMmI2ZGFmODQucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.Qm--43cnlvWHZxIxlNe9HygTSCgsCKh1-W365r_laxM',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 118,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_255,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 255,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_880,q_70,strp/<prettyName>-300w.jpg',
          h: 236,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_318,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 318,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_445,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 445,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_509,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 509,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1009,h_792,q_70,strp/<prettyName>-pre.jpg',
          h: 792,
          w: 1009,
          f: 1244466,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1009,h_792,q_70,strp/<prettyName>-pre.jpg',
          h: 792,
          w: 1009,
        },
        {
          t: 'fullview',
          r: 1,
          h: 880,
          w: 1120,
          f: 1244466,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/823485607/">KittenBee in Autumn</a> by <span class="username-with-symbol u"><a class="u premium username" href="https://www.deviantart.com/katiehofgard" target="_self">KatieHofgard</a><span class="user-symbol premium" data-quicktip-text="Core Member" data-show-tooltip="1" data-gruser-type="premium"></span></span>',
      time: '2020-01-06T00:00:00-0800',
      giver: {
        userId: 14113432,
        useridUuid: '209fee51-2b61-425a-9d6e-069bd1b9a1e5',
        username: 'RezaBisuto',
        usericon: 'https://a.deviantart.net/avatars-big/r/e/rezabisuto.jpg?12',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 824500693,
    typeId: 1,
    url: 'https://www.deviantart.com/drawloverlala/art/Merry-Christmas-Amy-Rose-in-the-Nutcracker-824500693',
    title: 'Merry Christmas!: Amy Rose in the Nutcracker.',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-12-23T19:29:58-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 17972182,
      useridUuid: '211e3554-4642-4ab0-b8b5-e73da180d0ff',
      username: 'Drawloverlala',
      usericon: 'https://a.deviantart.net/avatars-big/d/r/drawloverlala.png?6',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 261,
      favourites: 2461,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/211e3554-4642-4ab0-b8b5-e73da180d0ff/ddmvwt1-8d99f99a-c543-4997-b82f-e1c873b0326b.png',
      prettyName: 'merry_christmas___amy_rose_in_the_nutcracker__by_drawloverlala_ddmvwt1',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjQwMCIsInBhdGgiOiJcL2ZcLzIxMWUzNTU0LTQ2NDItNGFiMC1iOGI1LWU3M2RhMTgwZDBmZlwvZGRtdnd0MS04ZDk5Zjk5YS1jNTQzLTQ5OTctYjgyZi1lMWM4NzNiMDMyNmIucG5nIiwid2lkdGgiOiI8PTE2MDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.aro3ZVw53_7SpJqiN7EBNHvYVrfSZ_8x_AH_OfOLSZA',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 100,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_133,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 133,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 450,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/crop/w_167,h_250,x_0,y_0,scl_0.07952380952381,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 167,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_233,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 233,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/crop/w_267,h_400,x_0,y_0,scl_0.12714285714286,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 267,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_730,h_1095,q_70,strp/<prettyName>-pre.jpg',
          h: 1095,
          w: 730,
          f: 8987571,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_730,h_1095,q_70,strp/<prettyName>-pre.jpg',
          h: 1095,
          w: 730,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1600,h_2400,q_80,strp/<prettyName>-fullview.jpg',
          h: 2400,
          w: 1600,
          f: 8987571,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/824500693/">Merry Christmas!: Amy Rose in the Nutcracker.</a> by <span class="username-with-symbol u"><a class="u premium username" href="https://www.deviantart.com/drawloverlala" target="_self">Drawloverlala</a><span class="user-symbol premium" data-quicktip-text="Core Member" data-show-tooltip="1" data-gruser-type="premium"></span></span>',
      time: '2020-01-06T00:00:00-0800',
      giver: {
        userId: 16294182,
        useridUuid: '328fe1e6-c25e-4190-9946-7fa65f0bc65d',
        username: 'Astralseed',
        usericon: 'https://a.deviantart.net/avatars-big/a/s/astralseed.gif?3',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 824689612,
    typeId: 1,
    url: 'https://www.deviantart.com/hairbrainedscenes/art/Hall-of-Shadows-824689612',
    title: 'Hall of Shadows',
    isJournal: false,
    isPurchasable: true,
    publishedTime: '2019-12-25T14:39:46-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 21132103,
      useridUuid: '7dfcfa00-21fc-4114-988b-083066b57469',
      username: 'HairBrainedScenes',
      usericon: 'https://a.deviantart.net/avatars-big/h/a/hairbrainedscenes.jpg?5',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 12,
      favourites: 78,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/7dfcfa00-21fc-4114-988b-083066b57469/ddmzyks-23811d14-3d7f-482c-b964-3715c09e226a.jpg',
      prettyName: 'hall_of_shadows_by_hairbrainedscenes_ddmzyks',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTgyOSIsInBhdGgiOiJcL2ZcLzdkZmNmYTAwLTIxZmMtNDExNC05ODhiLTA4MzA2NmI1NzQ2OVwvZGRtenlrcy0yMzgxMWQxNC0zZDdmLTQ4MmMtYjk2NC0zNzE1YzA5ZTIyNmEuanBnIiwid2lkdGgiOiI8PTEyODAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ._DvzKKyUsJjYNODjr4BBxWw4Qkw_Y8B3-KFVcACjABw',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 105,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_140,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 140,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 429,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_175,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 175,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_245,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 245,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_280,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 280,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_748,h_1069,q_70,strp/<prettyName>-pre.jpg',
          h: 1069,
          w: 748,
          f: 7343087,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_748,h_1069,q_70,strp/<prettyName>-pre.jpg',
          h: 1069,
          w: 748,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1280,h_1829,q_75,strp/<prettyName>-fullview.jpg',
          h: 1829,
          w: 1280,
          f: 7343087,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/824689612/">Hall of Shadows</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/hairbrainedscenes" target="_self">HairBrainedScenes</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-06T00:00:00-0800',
      giver: {
        userId: 5020711,
        useridUuid: '42105a98-5a41-4f7b-b4aa-4d54ed92f994',
        username: 'C-91',
        usericon: 'https://a.deviantart.net/avatars-big/c/_/c-91.png?9',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 796744800,
    typeId: 1,
    url: 'https://www.deviantart.com/mimikascraftroom/art/The-Old-Ghost-Of-Doubt-796744800',
    title: 'The Old Ghost Of Doubt',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-05-07T02:18:53-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 5906918,
      useridUuid: '6b36580f-4a22-42cf-b759-5ad49e277f31',
      username: 'mimikascraftroom',
      usericon: 'https://a.deviantart.net/avatars-big/m/i/mimikascraftroom.jpg',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 49,
      favourites: 302,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/6b36580f-4a22-42cf-b759-5ad49e277f31/dd6d080-b0942e01-30d3-4861-bd8b-3ff519215020.jpg',
      prettyName: 'the_old_ghost_of_doubt_by_mimikascraftroom_dd6d080',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTAwIiwicGF0aCI6IlwvZlwvNmIzNjU4MGYtNGEyMi00MmNmLWI3NTktNWFkNDllMjc3ZjMxXC9kZDZkMDgwLWIwOTQyZTAxLTMwZDMtNDg2MS1iZDhiLTNmZjUxOTIxNTAyMC5qcGciLCJ3aWR0aCI6Ijw9NTYzIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.uXF6sBnL5hdsvFW7BDfg_feHi9aCb-UQj-rAQrXf96Y',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzZiMzY1ODBmLTRhMjItNDJjZi1iNzU5LTVhZDQ5ZTI3N2YzMVwvZGQ2ZDA4MC1iMDk0MmUwMS0zMGQzLTQ4NjEtYmQ4Yi0zZmY1MTkyMTUwMjAuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.NMZW093b7yACnvJE-n2JSsjqZTKTChNYnNvsFgcIRu4',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 94,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_125,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 125,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 480,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/crop/w_156,h_250,x_0,y_0,scl_0.27886323268206,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 156,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_219,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 219,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_250,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 250,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_563,h_900,q_75,strp/<prettyName>-fullview.jpg',
          h: 900,
          w: 563,
          f: 493976,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_563,h_900,q_75,strp/<prettyName>-fullview.jpg',
          h: 900,
          w: 563,
        },
        {
          t: 'fullview',
          r: 1,
          h: 900,
          w: 563,
          f: 493976,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/796744800/">The Old Ghost Of Doubt</a> by <span class="username-with-symbol u"><a class="u premium username" href="https://www.deviantart.com/mimikascraftroom" target="_self">mimikascraftroom</a><span class="user-symbol premium" data-quicktip-text="Core Member" data-show-tooltip="1" data-gruser-type="premium"></span></span>',
      time: '2020-01-06T00:00:00-0800',
      giver: {
        userId: 33790344,
        useridUuid: '6acb0fa3-dccb-4ce2-bfd4-3ea00f1958d5',
        username: 'Lora-Vysotskaya',
        usericon: 'https://a.deviantart.net/avatars-big/l/o/lora-vysotskaya.jpg?14',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 820603994,
    typeId: 1,
    url: 'https://www.deviantart.com/johnathanchong/art/Fighter-820603994',
    title: 'Fighter',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-11-17T10:57:57-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 18524872,
      useridUuid: 'c77f367a-4886-467a-b509-a194cf9a6aca',
      username: 'JohnathanChong',
      usericon: 'https://a.deviantart.net/avatars-big/j/o/johnathanchong.jpg?9',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 9,
      favourites: 330,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/c77f367a-4886-467a-b509-a194cf9a6aca/ddkke3e-e3c93ea4-0562-489b-893f-69f5a57372b2.jpg',
      prettyName: 'fighter_by_johnathanchong_ddkke3e',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTk0IiwicGF0aCI6IlwvZlwvYzc3ZjM2N2EtNDg4Ni00NjdhLWI1MDktYTE5NGNmOWE2YWNhXC9kZGtrZTNlLWUzYzkzZWE0LTA1NjItNDg5Yi04OTNmLTY5ZjVhNTczNzJiMi5qcGciLCJ3aWR0aCI6Ijw9MTYwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.AuG2wfSnkTE3yZPIgQejfQUTvZPjzrd1T2dyxIx869I',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 93,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_186,q_70,strp/<prettyName>-200h.jpg',
          h: 186,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 186,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_402,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 402,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_563,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 563,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_644,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 644,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1134,h_704,q_70,strp/<prettyName>-pre.jpg',
          h: 704,
          w: 1134,
          f: 1468773,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1134,h_704,q_70,strp/<prettyName>-pre.jpg',
          h: 704,
          w: 1134,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1600,h_994,q_75,strp/<prettyName>-fullview.jpg',
          h: 994,
          w: 1600,
          f: 1468773,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/820603994/">Fighter</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/johnathanchong" target="_self">JohnathanChong</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-06T00:00:00-0800',
      giver: {
        userId: 27220785,
        useridUuid: '5417d554-dc0f-4b19-ab80-c42562d36a72',
        username: 'lovelessdevotions',
        usericon: 'https://a.deviantart.net/avatars-big/l/o/lovelessdevotions.gif?6',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 749636508,
    typeId: 1,
    url: 'https://www.deviantart.com/cicique/art/The-Gossip-749636508',
    title: 'The Gossip',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-06-13T15:51:53-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 29656869,
      useridUuid: '68e4af4e-7e1f-4d32-84fe-8308c2463000',
      username: 'cicique',
      usericon: 'https://a.deviantart.net/avatars-big/c/i/cicique.jpg?4',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 14,
      favourites: 85,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/68e4af4e-7e1f-4d32-84fe-8308c2463000/dcebb8c-5178d875-41c8-4ef8-a17f-d5345a2eaf6c.jpg',
      prettyName: 'the_gossip_by_cicique_dcebb8c',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTc1MiIsInBhdGgiOiJcL2ZcLzY4ZTRhZjRlLTdlMWYtNGQzMi04NGZlLTgzMDhjMjQ2MzAwMFwvZGNlYmI4Yy01MTc4ZDg3NS00MWM4LTRlZjgtYTE3Zi1kNTM0NWEyZWFmNmMuanBnIiwid2lkdGgiOiI8PTE2MDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.cSHHpqSFn9YuFXfchJqILc5VYzWum9vdU1iBkLDvbiY',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 137,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_183,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 183,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 329,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_228,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 228,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_320,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 320,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_365,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 365,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_854,h_935,q_70,strp/<prettyName>-pre.jpg',
          h: 935,
          w: 854,
          f: 825559,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_854,h_935,q_70,strp/<prettyName>-pre.jpg',
          h: 935,
          w: 854,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1600,h_1752,q_75,strp/<prettyName>-fullview.jpg',
          h: 1752,
          w: 1600,
          f: 825559,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/749636508/">The Gossip</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/cicique" target="_self">cicique</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-06T00:00:00-0800',
      giver: {
        userId: 6324307,
        useridUuid: 'e3514b60-d214-4b75-9cdd-c328cf93abeb',
        username: 'SinistrosePhosphate',
        usericon: 'https://a.deviantart.net/avatars-big/s/i/sinistrosephosphate.gif?5',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 824873703,
    typeId: 1,
    url: 'https://www.deviantart.com/mechanicpigeon/art/Through-the-Dunes-adoptable-OPEN-824873703',
    title: 'Through the Dunes adoptable [OPEN]',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-12-27T09:54:36-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 27137164,
      useridUuid: '61125078-6479-48c6-a47f-4ef74fb3e871',
      username: 'MechanicPigeon',
      usericon: 'https://a.deviantart.net/avatars-big/m/e/mechanicpigeon.png?6',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 5,
      favourites: 110,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/61125078-6479-48c6-a47f-4ef74fb3e871/ddn3wmf-c260ac02-da73-42ee-ae7e-e7a8c1976d95.jpg',
      prettyName: 'through_the_dunes_adoptable__open__by_mechanicpigeon_ddn3wmf',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTUzMyIsInBhdGgiOiJcL2ZcLzYxMTI1MDc4LTY0NzktNDhjNi1hNDdmLTRlZjc0ZmIzZTg3MVwvZGRuM3dtZi1jMjYwYWMwMi1kYTczLTQyZWUtYWU3ZS1lN2E4YzE5NzZkOTUuanBnIiwid2lkdGgiOiI8PTE5MjAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.qkp7ClDZC1rsuqj35YwVcpp1psg7cFNjyhv7rUuX2Z0',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 120,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_251,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 250,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 240,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_313,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 313,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_439,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 438,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_501,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 501,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1000,h_799,q_70,strp/<prettyName>-pre.jpg',
          h: 799,
          w: 1000,
          f: 2963449,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1000,h_799,q_70,strp/<prettyName>-pre.jpg',
          h: 799,
          w: 1000,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1920,h_1533,q_75,strp/<prettyName>-fullview.jpg',
          h: 1533,
          w: 1920,
          f: 2963449,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/824873703/">Through the Dunes adoptable [OPEN]</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/mechanicpigeon" target="_self">MechanicPigeon</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-06T00:00:00-0800',
      giver: {
        userId: 5165001,
        useridUuid: 'aebd39d1-db07-4db5-8b83-8771baa355ab',
        username: 'DasGnomo',
        usericon: 'https://a.deviantart.net/avatars-big/d/a/dasgnomo.gif?8',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 811730151,
    typeId: 1,
    url: 'https://www.deviantart.com/foxjot/art/Solao-811730151',
    title: 'Solao',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-08-31T22:54:55-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 39074810,
      useridUuid: '53879288-ca60-42cc-a9b7-b4482533dfb4',
      username: 'Foxjot',
      usericon: 'https://a.deviantart.net/avatars-big/f/o/foxjot.png?5',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 34,
      favourites: 666,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/53879288-ca60-42cc-a9b7-b4482533dfb4/ddfa6zr-5d11f67b-431a-4b15-99b5-9a0db344feac.png',
      prettyName: 'solao_by_foxjot_ddfa6zr',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTQ3MiIsInBhdGgiOiJcL2ZcLzUzODc5Mjg4LWNhNjAtNDJjYy1hOWI3LWI0NDgyNTMzZGZiNFwvZGRmYTZ6ci01ZDExZjY3Yi00MzFhLTRiMTUtOTliNS05YTBkYjM0NGZlYWMucG5nIiwid2lkdGgiOiI8PTkwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.3v-FHHKFTFH43GUzLk9dIeGWjM1H_f_0Ix1DSbfvn4g',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 92,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/crop/w_122,h_200,x_0,y_0,scl_0.04469476744186,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 122,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 491,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_153,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 153,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_214,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 214,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/crop/w_245,h_400,x_0,y_0,scl_0.089026162790698,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 245,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_699,h_1143,q_70,strp/<prettyName>-pre.jpg',
          h: 1143,
          w: 699,
          f: 5641534,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_699,h_1143,q_70,strp/<prettyName>-pre.jpg',
          h: 1143,
          w: 699,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_900,h_1472,q_80,strp/<prettyName>-fullview.jpg',
          h: 1472,
          w: 900,
          f: 5641534,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/811730151/">Solao</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/foxjot" target="_self">Foxjot</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-06T00:00:00-0800',
      giver: {
        userId: 11880634,
        useridUuid: '709aedd4-65c1-424f-84e3-aad0bad1e224',
        username: 'TheGalleryOfEve',
        usericon: 'https://a.deviantart.net/avatars-big/t/h/thegalleryofeve.gif?1',
        type: 'volunteer',
        isNewDeviant: false,
      },
      suggester: {
        userId: 24162509,
        useridUuid: 'a9ded103-d80b-402b-b098-90ac2fc65429',
        username: 'LindArtz',
        usericon: 'https://a.deviantart.net/avatars-big/l/i/lindartz.gif?9',
        type: 'senior',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 813937988,
    typeId: 1,
    url: 'https://www.deviantart.com/ppeacht/art/It-s-My-Turn-to-Dream-813937988',
    title: "It's My Turn to Dream",
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-09-20T11:53:03-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 9894557,
      useridUuid: 'a98f02fe-13da-4fcb-89b4-cc6c6d21e528',
      username: 'Ppeacht',
      usericon: 'https://a.deviantart.net/avatars-big/p/p/ppeacht.gif?15',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 19,
      favourites: 197,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/a98f02fe-13da-4fcb-89b4-cc6c6d21e528/ddglikk-4e945b4c-0053-4124-90dd-920397a4ad7e.png',
      prettyName: 'it_s_my_turn_to_dream_by_ppeacht_ddglikk',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2E5OGYwMmZlLTEzZGEtNGZjYi04OWI0LWNjNmM2ZDIxZTUyOFwvZGRnbGlray00ZTk0NWI0Yy0wMDUzLTQxMjQtOTBkZC05MjAzOTdhNGFkN2UucG5nIiwiaGVpZ2h0IjoiPD0xMDY3Iiwid2lkdGgiOiI8PTgwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS53YXRlcm1hcmsiXSwid21rIjp7InBhdGgiOiJcL3dtXC9hOThmMDJmZS0xM2RhLTRmY2ItODliNC1jYzZjNmQyMWU1MjhcL3BwZWFjaHQtNC5wbmciLCJvcGFjaXR5Ijo5NSwicHJvcG9ydGlvbnMiOjAuNDUsImdyYXZpdHkiOiJjZW50ZXIifX0.dYOgHcwTOLKp_SfPeh37SI2pnGH62GUdqlnSqDMf7t8',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
          h: 150,
          w: 112,
          o: true,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_150,h_200,strp/<prettyName>-200h.png',
          h: 200,
          w: 150,
          o: true,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,strp/<prettyName>-300w.png',
          h: 400,
          w: 300,
          o: true,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/crop/w_188,h_250,x_0,y_0,scl_0.12533333333333,strp/<prettyName>-250t.png',
          h: 250,
          w: 187,
          o: true,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/crop/w_263,h_350,x_0,y_0,scl_0.17533333333333,strp/<prettyName>-350t.png',
          h: 350,
          w: 262,
          o: true,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_300,h_400,strp/<prettyName>-400t.png',
          h: 400,
          w: 300,
          o: true,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_774,h_1032,strp/<prettyName>-pre.png',
          h: 1032,
          w: 774,
          o: true,
          f: 1757967,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_774,h_1032,strp/<prettyName>-pre.png',
          h: 1032,
          w: 774,
          o: true,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_800,h_1067,strp/<prettyName>-fullview.png',
          h: 1067,
          w: 800,
          o: true,
          f: 1757967,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/813937988/">It\'s My Turn to Dream</a> by <span class="username-with-symbol u"><a class="u premium username" href="https://www.deviantart.com/ppeacht" target="_self">Ppeacht</a><span class="user-symbol premium" data-quicktip-text="Core Member" data-show-tooltip="1" data-gruser-type="premium"></span></span>',
      time: '2020-01-06T00:00:00-0800',
      giver: {
        userId: 1733358,
        useridUuid: 'eb30bc25-5eec-499a-bb0b-590b7354ef70',
        username: 'Thiefoworld',
        usericon: 'https://a.deviantart.net/avatars-big/t/h/thiefoworld.gif',
        type: 'volunteer',
        isNewDeviant: false,
      },
      suggester: {
        userId: 11880634,
        useridUuid: '709aedd4-65c1-424f-84e3-aad0bad1e224',
        username: 'TheGalleryOfEve',
        usericon: 'https://a.deviantart.net/avatars-big/t/h/thegalleryofeve.gif?1',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 825653835,
    typeId: 1,
    url: 'https://www.deviantart.com/sr1023/art/251219-825653835',
    title: '251219',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-02T22:08:35-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 42039839,
      useridUuid: 'be3ee8b5-004d-4cb0-918f-a83cd842d454',
      username: 'sr1023',
      usericon: 'https://a.deviantart.net/avatars-big/s/r/sr1023.gif?4',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 21,
      favourites: 234,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/be3ee8b5-004d-4cb0-918f-a83cd842d454/ddnkmkr-78f8d0f0-71f2-4d15-b238-9822019daffa.png',
      prettyName: '251219_by_sr1023_ddnkmkr',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODAwIiwicGF0aCI6IlwvZlwvYmUzZWU4YjUtMDA0ZC00Y2IwLTkxOGYtYTgzY2Q4NDJkNDU0XC9kZG5rbWtyLTc4ZjhkMGYwLTcxZjItNGQxNS1iMjM4LTk4MjIwMTlkYWZmYS5wbmciLCJ3aWR0aCI6Ijw9MTIwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.uegBDcnCMXP3SJD3bnyWwr9GzRXolW3Tte2EFRk5dW4',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2JlM2VlOGI1LTAwNGQtNGNiMC05MThmLWE4M2NkODQyZDQ1NFwvZGRua21rci03OGY4ZDBmMC03MWYyLTRkMTUtYjIzOC05ODIyMDE5ZGFmZmEucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.CFn0jOasXDD4Tuid5ZOKInj7vMjjFto3lYBC5J7b2nk',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 100,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_800,q_70,strp/<prettyName>-300w.jpg',
          h: 200,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 375,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_525,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 525,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_600,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 600,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1095,h_730,q_70,strp/<prettyName>-pre.jpg',
          h: 730,
          w: 1095,
          f: 777502,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1095,h_730,q_70,strp/<prettyName>-pre.jpg',
          h: 730,
          w: 1095,
        },
        {
          t: 'fullview',
          r: 1,
          h: 800,
          w: 1200,
          f: 777502,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/825653835/">251219</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/sr1023" target="_self">sr1023</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-06T00:00:00-0800',
      giver: {
        userId: 541228,
        useridUuid: '5595eaf4-9d27-44b9-a2e9-3c113acd9049',
        username: 'Moonbeam13',
        usericon: 'https://a.deviantart.net/avatars-big/m/o/moonbeam13.gif?5',
        type: 'admin',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 825800115,
    typeId: 1,
    url: 'https://www.deviantart.com/frauhaku/art/One-hand-gives-the-other-takes-away-Part-1-825800115',
    title: 'One hand gives, the other takes away | Part 1',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-04T05:30:02-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 44289118,
      useridUuid: 'd009fb76-730f-41e5-a76c-bb28d5ff0b40',
      username: 'FrauHaku',
      usericon: 'https://a.deviantart.net/avatars-big/f/r/frauhaku.jpg?12',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 5,
      favourites: 56,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/d009fb76-730f-41e5-a76c-bb28d5ff0b40/ddnnrg3-cbef81b3-f5e8-4f45-ae06-91c7a4e74391.jpg',
      prettyName: 'one_hand_gives__the_other_takes_away___part_1_by_frauhaku_ddnnrg3',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTMwMCIsInBhdGgiOiJcL2ZcL2QwMDlmYjc2LTczMGYtNDFlNS1hNzZjLWJiMjhkNWZmMGI0MFwvZGRubnJnMy1jYmVmODFiMy1mNWU4LTRmNDUtYWUwNi05MWM3YTRlNzQzOTEuanBnIiwid2lkdGgiOiI8PTg2NyJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.XKsfzWICtQ2h2VIkNE9w8yx8Sfy1Xums1p3B3eIKm7Y',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2QwMDlmYjc2LTczMGYtNDFlNS1hNzZjLWJiMjhkNWZmMGI0MFwvZGRubnJnMy1jYmVmODFiMy1mNWU4LTRmNDUtYWUwNi05MWM3YTRlNzQzOTEuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.G6sRqJWUOcqS3WSrpnnQtWt5O3Rup9P1VnxSpcdaBSs',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 100,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/crop/w_133,h_200,x_0,y_0,scl_0.15455594002307,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 133,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 450,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_167,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 167,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/crop/w_233,h_350,x_0,y_0,scl_0.26989619377163,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 233,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_267,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 267,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_730,h_1095,q_70,strp/<prettyName>-pre.jpg',
          h: 1095,
          w: 730,
          f: 909711,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_730,h_1095,q_70,strp/<prettyName>-pre.jpg',
          h: 1095,
          w: 730,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1300,
          w: 867,
          f: 909711,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/825800115/">One hand gives, the other takes away | Part 1</a> by <span class="username-with-symbol u"><a class="u premium username" href="https://www.deviantart.com/frauhaku" target="_self">FrauHaku</a><span class="user-symbol premium" data-quicktip-text="Core Member" data-show-tooltip="1" data-gruser-type="premium"></span></span>',
      time: '2020-01-06T00:00:00-0800',
      giver: {
        userId: 4837142,
        useridUuid: '7adc5a6c-2e61-4e55-8f33-fabe92a17312',
        username: 'pullingcandy',
        usericon: 'https://a.deviantart.net/avatars-big/p/u/pullingcandy.jpg',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 762876263,
    typeId: 1,
    url: 'https://www.deviantart.com/semanie/art/Technomancy-1-Landfall-762876263',
    title: 'Technomancy 1 Landfall',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-09-06T14:16:08-0700',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/762876263',
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 40836035,
      useridUuid: '353c6426-2927-44ee-b595-d1d7cf876bee',
      username: 'Semanie',
      usericon: 'https://a.deviantart.net/avatars-big/s/e/semanie.jpg?4',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 1,
      favourites: 10,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/353c6426-2927-44ee-b595-d1d7cf876bee/dcm733b-8e986f23-ff4a-49fc-8a2f-0c2dab80c3ec.jpg',
      prettyName: 'technomancy_1_landfall_by_semanie_dcm733b',
      types: [
        {
          t: 'preview',
          r: -1,
          c: 'v1/fill/w_300,h_367,q_75,strp/<prettyName>-fullview.jpg',
          h: 367,
          w: 300,
          f: 92047,
        },
        {
          t: 'social_preview',
          r: -1,
          c: 'v1/fill/w_300,h_367,q_75,strp/<prettyName>-fullview.jpg',
          h: 367,
          w: 300,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/762876263/">Technomancy 1 Landfall</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/semanie" target="_self">Semanie</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-06T00:00:00-0800',
      giver: {
        userId: 17191616,
        useridUuid: '5afef651-c22b-4f38-a512-25dbf7007732',
        username: 'Zara-Arletis',
        usericon: 'https://a.deviantart.net/avatars-big/z/a/zara-arletis.png?12',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
    textContent: {
      excerpt:
        'The airship creaked as it surged against the headwinds that heralded landfall. Below, canals, broad boulevards and gingerbread buildings came into view. The city state of Toreningan was pretty as a picture but to the magical painter artist and Sybil Aurimeda Contelorius it was simply so much more than that. To her it was home, she was returning to her husband and estate after a lengthier tour abroad with her paintings. A tour involving several exhibitions in many a large city where she had sold a lot but also found the time and inspiration to paint new works. A tour where colour tubes, canvases and paintbrushes had been her constant companion',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 769763830,
    typeId: 1,
    url: 'https://www.deviantart.com/gigicave/art/Tintoretto-ramake-769763830',
    title: 'Tintoretto ramake',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-10-25T03:18:03-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 2080320,
      useridUuid: '3661af4a-5acd-4f1f-befb-86abd0782d4d',
      username: 'GigiCave',
      usericon: 'https://a.deviantart.net/avatars-big/g/i/gigicave.gif',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 16,
      favourites: 508,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/3661af4a-5acd-4f1f-befb-86abd0782d4d/dcqapkm-b3b5523f-68d5-4c70-8b18-e3005ae93638.jpg',
      prettyName: 'tintoretto_ramake_by_gigicave_dcqapkm',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTAwIiwicGF0aCI6IlwvZlwvMzY2MWFmNGEtNWFjZC00ZjFmLWJlZmItODZhYmQwNzgyZDRkXC9kY3FhcGttLWIzYjU1MjNmLTY4ZDUtNGM3MC04YjE4LWUzMDA1YWU5MzYzOC5qcGciLCJ3aWR0aCI6Ijw9NTA3In1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.V7LTQQAUKkUU9g6yhk3VikvZWt-Izs1su6KBc53pzHw',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzM2NjFhZjRhLTVhY2QtNGYxZi1iZWZiLTg2YWJkMDc4MmQ0ZFwvZGNxYXBrbS1iM2I1NTIzZi02OGQ1LTRjNzAtOGIxOC1lMzAwNWFlOTM2MzguanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.yrsBUfO5EvWzr_20FnMBjpUyL8895oS05ELlPth-Qf8',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 85,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/crop/w_113,h_200,x_0,y_0,scl_0.22287968441815,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 113,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 533,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_141,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 141,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_197,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 197,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/crop/w_225,h_400,x_0,y_0,scl_0.44575936883629,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 225,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_507,h_900,q_75,strp/<prettyName>-fullview.jpg',
          h: 900,
          w: 507,
          f: 299346,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_507,h_900,q_75,strp/<prettyName>-fullview.jpg',
          h: 900,
          w: 507,
        },
        {
          t: 'fullview',
          r: 1,
          h: 900,
          w: 507,
          f: 299346,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/769763830/">Tintoretto ramake</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/gigicave" target="_self">GigiCave</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-05T00:00:00-0800',
      giver: {
        userId: 27220785,
        useridUuid: '5417d554-dc0f-4b19-ab80-c42562d36a72',
        username: 'lovelessdevotions',
        usericon: 'https://a.deviantart.net/avatars-big/l/o/lovelessdevotions.gif?6',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 822414974,
    typeId: 1,
    url: 'https://www.deviantart.com/sylviaritter/art/Speedpainting-04122019-822414974',
    title: 'Speedpainting 04122019',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-12-04T07:58:23-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 6528901,
      useridUuid: 'de96a427-aecc-41f3-8e1b-3a425360d246',
      username: 'SylviaRitter',
      usericon: 'https://a.deviantart.net/avatars-big/s/y/sylviaritter.jpg?10',
      type: 'hell-beta',
      isNewDeviant: false,
    },
    stats: {
      comments: 12,
      favourites: 424,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/de96a427-aecc-41f3-8e1b-3a425360d246/ddln7ge-1201df35-7553-43fd-8aae-8209f9c0b0d8.jpg',
      prettyName: 'speedpainting_04122019_by_sylviaritter_ddln7ge',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTA4MCIsInBhdGgiOiJcL2ZcL2RlOTZhNDI3LWFlY2MtNDFmMy04ZTFiLTNhNDI1MzYwZDI0NlwvZGRsbjdnZS0xMjAxZGYzNS03NTUzLTQzZmQtOGFhZS04MjA5ZjljMGIwZDguanBnIiwid2lkdGgiOiI8PTE5MjAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.F1hvZIJH-65cEP_dU_hRHAIosBFQzhvgmx2VxO36mxg',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2RlOTZhNDI3LWFlY2MtNDFmMy04ZTFiLTNhNDI1MzYwZDI0NlwvZGRsbjdnZS0xMjAxZGYzNS03NTUzLTQzZmQtOGFhZS04MjA5ZjljMGIwZDguanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.QGbPMe-Ql-mInP0VMj0Yy-wxjY2fCSxp2Vn8JmfIjzk',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 141142,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1080,
          w: 1920,
          f: 141142,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/822414974/">Speedpainting 04122019</a> by <span class="username-with-symbol u"><a class="u hell-beta username" href="https://www.deviantart.com/sylviaritter" target="_self">SylviaRitter</a><span class="user-symbol hell-beta" data-quicktip-text="Beta Tester &#039;til Hell Freezes Over" data-show-tooltip="1" data-gruser-type="hell-beta"></span></span>',
      time: '2020-01-05T00:00:00-0800',
      giver: {
        userId: 22533787,
        useridUuid: 'faa48d2d-12c2-43d1-bf23-b5e99857825b',
        username: 'Ellysiumn',
        usericon: 'https://a.deviantart.net/avatars-big/e/l/ellysiumn.png?8',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 819688945,
    typeId: 1,
    url: 'https://www.deviantart.com/indojo/art/Dsc0134-819688945',
    title: ' Dsc0134',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-11-09T00:02:17-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 11252630,
      useridUuid: '69fbcf91-7ca6-4f0e-a268-fb368baf3cd0',
      username: 'indojo',
      usericon: 'https://a.deviantart.net/avatars-big/i/n/indojo.gif?2',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 42,
      favourites: 329,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/69fbcf91-7ca6-4f0e-a268-fb368baf3cd0/ddk0s1d-751da25c-aab9-495f-bf3b-18b6e98f929e.jpg',
      prettyName: '_dsc0134_by_indojo_ddk0s1d',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTM0IiwicGF0aCI6IlwvZlwvNjlmYmNmOTEtN2NhNi00ZjBlLWEyNjgtZmIzNjhiYWYzY2QwXC9kZGswczFkLTc1MWRhMjVjLWFhYjktNDk1Zi1iZjNiLTE4YjZlOThmOTI5ZS5qcGciLCJ3aWR0aCI6Ijw9ODAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.sngvQxHqev-uKOMFGPQhbB05V2HcIB2e9X5IcuUhpsY',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzY5ZmJjZjkxLTdjYTYtNGYwZS1hMjY4LWZiMzY4YmFmM2NkMFwvZGRrMHMxZC03NTFkYTI1Yy1hYWI5LTQ5NWYtYmYzYi0xOGI2ZTk4ZjkyOWUuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.9uJbVtbER0VwI5PjTyKl0mgEiVIDT6AjAMFxYXtPrk4',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 100,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_534,q_70,strp/<prettyName>-300w.jpg',
          h: 200,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 375,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_524,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 524,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_599,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 599,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_800,h_534,q_75,strp/<prettyName>-fullview.jpg',
          h: 534,
          w: 800,
          f: 240947,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_800,h_534,q_75,strp/<prettyName>-fullview.jpg',
          h: 534,
          w: 800,
        },
        {
          t: 'fullview',
          r: 1,
          h: 534,
          w: 800,
          f: 240947,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/819688945/"> Dsc0134</a> by <span class="username-with-symbol u"><a class="u premium username" href="https://www.deviantart.com/indojo" target="_self">indojo</a><span class="user-symbol premium" data-quicktip-text="Core Member" data-show-tooltip="1" data-gruser-type="premium"></span></span>',
      time: '2020-01-05T00:00:00-0800',
      giver: {
        userId: 1020294,
        useridUuid: '567905cc-8ba0-42d4-af01-054697b8fab6',
        username: 'JenFruzz',
        usericon: 'https://a.deviantart.net/avatars-big/j/e/jenfruzz.gif?6',
        type: 'volunteer',
        isNewDeviant: false,
      },
      suggester: {
        userId: 20077342,
        useridUuid: 'eac6344d-4dad-4d7a-931e-d32018c03973',
        username: 'SavageFrog',
        usericon: 'https://a.deviantart.net/avatars-big/s/a/savagefrog.gif?1',
        type: 'senior',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 824990632,
    typeId: 1,
    url: 'https://www.deviantart.com/maxbedulenko/art/Lisbon-824990632',
    title: 'Lisbon',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-12-28T10:20:28-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 37442249,
      useridUuid: 'b6d69103-8f51-4b31-9b10-3d2041a9224b',
      username: 'MaxBedulenko',
      usericon: 'https://a.deviantart.net/avatars-big/m/a/maxbedulenko.jpg?5',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 9,
      favourites: 254,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/b6d69103-8f51-4b31-9b10-3d2041a9224b/ddn6eug-65ffb2cc-2345-4dfe-bc67-9cfe9af7fc16.jpg',
      prettyName: 'lisbon_by_maxbedulenko_ddn6eug',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9Njc4IiwicGF0aCI6IlwvZlwvYjZkNjkxMDMtOGY1MS00YjMxLTliMTAtM2QyMDQxYTkyMjRiXC9kZG42ZXVnLTY1ZmZiMmNjLTIzNDUtNGRmZS1iYzY3LTljZmU5YWY3ZmMxNi5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.iYkYZTBisUivIWvbwEr7sh7GT8LIUoK_aBNbDGBAovc',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 79,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_159,q_70,strp/<prettyName>-200h.jpg',
          h: 159,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_678,q_70,strp/<prettyName>-300w.jpg',
          h: 159,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_473,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 472,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_662,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 661,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_756,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 755,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1228,h_650,q_70,strp/<prettyName>-pre.jpg',
          h: 650,
          w: 1228,
          f: 9173104,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1228,h_650,q_70,strp/<prettyName>-pre.jpg',
          h: 650,
          w: 1228,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1280,h_678,q_75,strp/<prettyName>-fullview.jpg',
          h: 678,
          w: 1280,
          f: 9173104,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/824990632/">Lisbon</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/maxbedulenko" target="_self">MaxBedulenko</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-05T00:00:00-0800',
      giver: {
        userId: 541228,
        useridUuid: '5595eaf4-9d27-44b9-a2e9-3c113acd9049',
        username: 'Moonbeam13',
        usericon: 'https://a.deviantart.net/avatars-big/m/o/moonbeam13.gif?5',
        type: 'admin',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 817932081,
    typeId: 1,
    url: 'https://www.deviantart.com/dj-applej-sound/art/Echoes-817932081',
    title: 'Echoes',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-10-24T13:31:32-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 25926603,
      useridUuid: 'e41fdf46-548b-439f-84f7-28c3545de3b4',
      username: 'DJ-AppleJ-Sound',
      usericon: 'https://a.deviantart.net/avatars-big/d/j/dj-applej-sound.jpg',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 20,
      favourites: 231,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e41fdf46-548b-439f-84f7-28c3545de3b4/ddiz4fl-b31150e9-7467-40c4-aab6-3c64beec7464.png',
      prettyName: 'echoes_by_dj_applej_sound_ddiz4fl',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTA4MCIsInBhdGgiOiJcL2ZcL2U0MWZkZjQ2LTU0OGItNDM5Zi04NGY3LTI4YzM1NDVkZTNiNFwvZGRpejRmbC1iMzExNTBlOS03NDY3LTQwYzQtYWFiNi0zYzY0YmVlYzc0NjQucG5nIiwid2lkdGgiOiI8PTE5MjAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.JSAxdoVSrhAN7xXZldia9FOAJLn9fQDTotjCeLisMZg',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2U0MWZkZjQ2LTU0OGItNDM5Zi04NGY3LTI4YzM1NDVkZTNiNFwvZGRpejRmbC1iMzExNTBlOS03NDY3LTQwYzQtYWFiNi0zYzY0YmVlYzc0NjQucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.NGrZjNGK6LIY_cjnF9m0cR4NijpCOXt5YiCS9GeD2I4',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 1830242,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1080,
          w: 1920,
          f: 1830242,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/817932081/">Echoes</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/dj-applej-sound" target="_self">DJ-AppleJ-Sound</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-05T00:00:00-0800',
      giver: {
        userId: 33790344,
        useridUuid: '6acb0fa3-dccb-4ce2-bfd4-3ea00f1958d5',
        username: 'Lora-Vysotskaya',
        usericon: 'https://a.deviantart.net/avatars-big/l/o/lora-vysotskaya.jpg?14',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 773936311,
    typeId: 1,
    url: 'https://www.deviantart.com/freemind93/art/Auction-773936311',
    title: 'Auction',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-11-24T09:47:51-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 13403335,
      useridUuid: '5cc591ca-fd40-489d-8a64-98c601f565de',
      username: 'FreeMind93',
      usericon: 'https://a.deviantart.net/avatars-big/f/r/freemind93.jpg?8',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 12,
      favourites: 233,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/5cc591ca-fd40-489d-8a64-98c601f565de/dcss52v-3ff71cd4-0c3b-478c-a43f-3246cc755a59.jpg',
      prettyName: 'auction_by_freemind93_dcss52v',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODk1IiwicGF0aCI6IlwvZlwvNWNjNTkxY2EtZmQ0MC00ODlkLThhNjQtOThjNjAxZjU2NWRlXC9kY3NzNTJ2LTNmZjcxY2Q0LTBjM2ItNDc4Yy1hNDNmLTMyNDZjYzc1NWE1OS5qcGciLCJ3aWR0aCI6Ijw9MTYwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.Bh4rhprwgNQ57rC09nkBdlPkpFpfKvNhZxJHgxBOn8c',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_168,q_70,strp/<prettyName>-200h.jpg',
          h: 168,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_895,q_70,strp/<prettyName>-300w.jpg',
          h: 168,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_447,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 447,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_626,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 626,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_716,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 715,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1195,h_668,q_70,strp/<prettyName>-pre.jpg',
          h: 668,
          w: 1195,
          f: 1689626,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1195,h_668,q_70,strp/<prettyName>-pre.jpg',
          h: 668,
          w: 1195,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1600,h_895,q_75,strp/<prettyName>-fullview.jpg',
          h: 895,
          w: 1600,
          f: 1689626,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/773936311/">Auction</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/freemind93" target="_self">FreeMind93</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-05T00:00:00-0800',
      giver: {
        userId: 374345,
        useridUuid: 'ac9c6a6e-909d-49b0-b6b1-223e72a0152e',
        username: 'cosmicbound',
        usericon: 'https://a.deviantart.net/avatars-big/c/o/cosmicbound.gif?1',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 823990366,
    typeId: 1,
    url: 'https://www.deviantart.com/pauldng/art/My-Bedroom-823990366',
    title: 'My Bedroom',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-12-19T00:29:27-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 2061019,
      useridUuid: 'cbd5f73c-7eb8-4e2d-99de-868755438c9b',
      username: 'pauldng',
      usericon: 'https://a.deviantart.net/avatars-big/p/a/pauldng.jpg?11',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 11,
      favourites: 162,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/cbd5f73c-7eb8-4e2d-99de-868755438c9b/ddmkz1a-5b4d37fb-5945-4ea8-813b-94339d2673a8.jpg',
      prettyName: 'my_bedroom_by_pauldng_ddmkz1a',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzY0IiwicGF0aCI6IlwvZlwvY2JkNWY3M2MtN2ViOC00ZTJkLTk5ZGUtODY4NzU1NDM4YzliXC9kZG1rejFhLTViNGQzN2ZiLTU5NDUtNGVhOC04MTNiLTk0MzM5ZDI2NzNhOC5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.Iu2wXXa2i-JX2DAQk_41hUY9bo1aagVscl4jI1jwmgQ',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 90,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_179,q_70,strp/<prettyName>-200h.jpg',
          h: 179,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_764,q_70,strp/<prettyName>-300w.jpg',
          h: 179,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_419,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 419,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_587,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 586,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_670,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 670,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1157,h_691,q_70,strp/<prettyName>-pre.jpg',
          h: 691,
          w: 1157,
          f: 1431463,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1157,h_691,q_70,strp/<prettyName>-pre.jpg',
          h: 691,
          w: 1157,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1280,h_764,q_75,strp/<prettyName>-fullview.jpg',
          h: 764,
          w: 1280,
          f: 1431463,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/823990366/">My Bedroom</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/pauldng" target="_self">pauldng</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-05T00:00:00-0800',
      giver: {
        userId: 11880634,
        useridUuid: '709aedd4-65c1-424f-84e3-aad0bad1e224',
        username: 'TheGalleryOfEve',
        usericon: 'https://a.deviantart.net/avatars-big/t/h/thegalleryofeve.gif?1',
        type: 'volunteer',
        isNewDeviant: false,
      },
      suggester: {
        userId: 1206968,
        useridUuid: 'd218907d-0c0c-4d60-8653-c9662006ad3a',
        username: 'barananduen',
        usericon: 'https://a.deviantart.net/avatars-big/b/a/barananduen.jpg?6',
        type: 'beta',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 825275359,
    typeId: 1,
    url: 'https://www.deviantart.com/fade--touched/art/Dreaming-in-Light-825275359',
    title: 'Dreaming in Light',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-12-30T19:38:57-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 1029183,
      useridUuid: '6c19f66d-1574-4bc4-9425-83b0732e7093',
      username: 'Fade--Touched',
      usericon: 'https://a.deviantart.net/avatars-big/f/a/fade--touched.png?13',
      type: 'beta',
      isNewDeviant: false,
    },
    stats: {
      comments: 32,
      favourites: 120,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/6c19f66d-1574-4bc4-9425-83b0732e7093/ddncijj-573c7d27-b151-48f3-b905-4e95b0f0d492.png',
      prettyName: 'dreaming_in_light_by_fade__touched_ddncijj',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTEwMiIsInBhdGgiOiJcL2ZcLzZjMTlmNjZkLTE1NzQtNGJjNC05NDI1LTgzYjA3MzJlNzA5M1wvZGRuY2lqai01NzNjN2QyNy1iMTUxLTQ4ZjMtYjkwNS00ZTk1YjBmMGQ0OTIucG5nIiwid2lkdGgiOiI8PTkwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.PN1FE81BqaB9mUPyg2NwpzHUDThFjufHmyira_xp2N8',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
          h: 150,
          w: 123,
          o: true,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/crop/w_163,h_200,x_0,y_0,scl_0.089130434782609,strp/<prettyName>-200h.png',
          h: 200,
          w: 163,
          o: true,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,strp/<prettyName>-300w.png',
          h: 367,
          w: 300,
          o: true,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_204,h_250,strp/<prettyName>-250t.png',
          h: 250,
          w: 204,
          o: true,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_286,h_350,strp/<prettyName>-350t.png',
          h: 350,
          w: 286,
          o: true,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_327,h_400,strp/<prettyName>-400t.png',
          h: 400,
          w: 327,
          o: true,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_808,h_989,strp/<prettyName>-pre.png',
          h: 989,
          w: 808,
          o: true,
          f: 2798374,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_808,h_989,strp/<prettyName>-pre.png',
          h: 989,
          w: 808,
          o: true,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_900,h_1102,strp/<prettyName>-fullview.png',
          h: 1102,
          w: 900,
          o: true,
          f: 2798374,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/825275359/">Dreaming in Light</a> by <span class="username-with-symbol u"><a class="u beta username" href="https://www.deviantart.com/fade--touched" target="_self">Fade--Touched</a><span class="user-symbol beta" data-quicktip-text="Beta Tester" data-show-tooltip="1" data-gruser-type="beta"></span></span>',
      time: '2020-01-05T00:00:00-0800',
      giver: {
        userId: 14113432,
        useridUuid: '209fee51-2b61-425a-9d6e-069bd1b9a1e5',
        username: 'RezaBisuto',
        usericon: 'https://a.deviantart.net/avatars-big/r/e/rezabisuto.jpg?12',
        type: 'volunteer',
        isNewDeviant: false,
      },
      suggester: {
        userId: 925530,
        useridUuid: '7a17e722-f8df-4659-b2c6-95c4c1c282f1',
        username: 'Winzer',
        usericon: 'https://a.deviantart.net/avatars-big/w/i/winzer.gif?3',
        type: 'premium',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 821241955,
    typeId: 1,
    url: 'https://www.deviantart.com/bluewolfcheetah/art/Blue-Carpenter-Bee-Backpack-821241955',
    title: 'Blue Carpenter Bee Backpack',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-11-23T14:31:29-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 2470832,
      useridUuid: '5f2f541f-93e9-4165-bfe4-e64a0cafb275',
      username: 'BlueWolfCheetah',
      usericon: 'https://a.deviantart.net/avatars-big/b/l/bluewolfcheetah.png?8',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 24,
      favourites: 282,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/5f2f541f-93e9-4165-bfe4-e64a0cafb275/ddky2cj-852cd393-7ea8-4796-9caa-c88074049263.png',
      prettyName: 'blue_carpenter_bee_backpack_by_bluewolfcheetah_ddky2cj',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTYwMCIsInBhdGgiOiJcL2ZcLzVmMmY1NDFmLTkzZTktNDE2NS1iZmU0LWU2NGEwY2FmYjI3NVwvZGRreTJjai04NTJjZDM5My03ZWE4LTQ3OTYtOWNhYS1jODgwNzQwNDkyNjMucG5nIiwid2lkdGgiOiI8PTE2MDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.KiIFjgMHL9181iJGY96QUYsljR8eVp8Yf2TRJxEjlr8',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_200,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 200,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 300,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_250,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 250,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_350,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 350,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_400,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 400,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
          f: 5446290,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1600,h_1600,q_80,strp/<prettyName>-fullview.jpg',
          h: 1600,
          w: 1600,
          f: 5446290,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/821241955/">Blue Carpenter Bee Backpack</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/bluewolfcheetah" target="_self">BlueWolfCheetah</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-05T00:00:00-0800',
      giver: {
        userId: 6324307,
        useridUuid: 'e3514b60-d214-4b75-9cdd-c328cf93abeb',
        username: 'SinistrosePhosphate',
        usericon: 'https://a.deviantart.net/avatars-big/s/i/sinistrosephosphate.gif?5',
        type: 'volunteer',
        isNewDeviant: false,
      },
      suggester: {
        userId: 36634274,
        useridUuid: '3d565081-7ad3-49b3-a61d-5734e1e1bc4d',
        username: 'craftsbyblue',
        usericon: 'https://a.deviantart.net/avatars-big/c/r/craftsbyblue.jpg?6',
        type: 'beta',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 824634847,
    typeId: 1,
    url: 'https://www.deviantart.com/nipuni/art/Flowers-for-the-dead-824634847',
    title: 'Flowers for the dead',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-12-25T02:03:17-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 13717277,
      useridUuid: '305cad4f-938c-4d5e-91c3-9c9f62cd8c99',
      username: 'nipuni',
      usericon: 'https://a.deviantart.net/avatars-big/n/i/nipuni.png?7',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 9,
      favourites: 257,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/305cad4f-938c-4d5e-91c3-9c9f62cd8c99/ddmysbj-6558a7a3-fa32-46c2-b4c9-94fd03d40fe6.png',
      prettyName: 'flowers_for_the_dead_by_nipuni_ddmysbj',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTAwMSIsInBhdGgiOiJcL2ZcLzMwNWNhZDRmLTkzOGMtNGQ1ZS05MWMzLTljOWY2MmNkOGM5OVwvZGRteXNiai02NTU4YTdhMy1mYTMyLTQ2YzItYjRjOS05NGZkMDNkNDBmZTYucG5nIiwid2lkdGgiOiI8PTYwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.JiCwOrxamfwzPI3UOuJzFaSazFTTRDuIhKxKJsL-t_A',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 90,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_120,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 120,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 501,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_150,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 150,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_210,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 210,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_240,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 240,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_600,h_1001,q_80,strp/<prettyName>-fullview.jpg',
          h: 1001,
          w: 600,
          f: 2325891,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_600,h_1001,q_80,strp/<prettyName>-fullview.jpg',
          h: 1001,
          w: 600,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_600,h_1001,q_80,strp/<prettyName>-fullview.jpg',
          h: 1001,
          w: 600,
          f: 2325891,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/824634847/">Flowers for the dead</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/nipuni" target="_self">nipuni</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-05T00:00:00-0800',
      giver: {
        userId: 16294182,
        useridUuid: '328fe1e6-c25e-4190-9946-7fa65f0bc65d',
        username: 'Astralseed',
        usericon: 'https://a.deviantart.net/avatars-big/a/s/astralseed.gif?3',
        type: 'volunteer',
        isNewDeviant: false,
      },
      suggester: {
        userId: 1206968,
        useridUuid: 'd218907d-0c0c-4d60-8653-c9662006ad3a',
        username: 'barananduen',
        usericon: 'https://a.deviantart.net/avatars-big/b/a/barananduen.jpg?6',
        type: 'beta',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 817912621,
    typeId: 1,
    url: 'https://www.deviantart.com/pixiepokers/art/The-Thenardiers-Les-Miserables-817912621',
    title: 'The Thenardiers (Les Miserables)',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-10-24T10:42:37-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 22428218,
      useridUuid: '6a4f1045-5310-488a-b863-31cbccc95efc',
      username: 'PixiePokers',
      usericon: 'https://a.deviantart.net/avatars-big/p/i/pixiepokers.jpg?9',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 4,
      favourites: 32,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/6a4f1045-5310-488a-b863-31cbccc95efc/ddiypf1-c7d6c964-edd7-44e0-b4bd-12c75299eef6.jpg',
      prettyName: 'the_thenardiers__les_miserables__by_pixiepokers_ddiypf1',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTc1IiwicGF0aCI6IlwvZlwvNmE0ZjEwNDUtNTMxMC00ODhhLWI4NjMtMzFjYmNjYzk1ZWZjXC9kZGl5cGYxLWM3ZDZjOTY0LWVkZDctNDRlMC1iNGJkLTEyYzc1Mjk5ZWVmNi5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.qMSxEx7kqqm0CIinXIPsm_4-fZuzgkPHAJI_Y98ByQ4',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_168,q_70,strp/<prettyName>-200h.jpg',
          h: 168,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_575,q_70,strp/<prettyName>-300w.jpg',
          h: 168,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_445,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 445,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_624,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 623,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_713,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 712,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1024,h_575,q_75,strp/<prettyName>-fullview.jpg',
          h: 575,
          w: 1024,
          f: 6446833,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1024,h_575,q_75,strp/<prettyName>-fullview.jpg',
          h: 575,
          w: 1024,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1024,h_575,q_75,strp/<prettyName>-fullview.jpg',
          h: 575,
          w: 1024,
          f: 6446833,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/817912621/">The Thenardiers (Les Miserables)</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/pixiepokers" target="_self">PixiePokers</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-05T00:00:00-0800',
      giver: {
        userId: 4837142,
        useridUuid: '7adc5a6c-2e61-4e55-8f33-fabe92a17312',
        username: 'pullingcandy',
        usericon: 'https://a.deviantart.net/avatars-big/p/u/pullingcandy.jpg',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
  },
  {
    deviationId: 822719184,
    typeId: 1,
    url: 'https://www.deviantart.com/e-a-photography/art/Still-Esmeralda-Belladone-822719184',
    title: 'Still - Esmeralda Belladone',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-12-07T04:59:05-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 44293020,
      useridUuid: '619afafd-a876-4e65-a618-f7286c0d381e',
      username: 'E-A-photography',
      usericon: 'https://a.deviantart.net/avatars-big/e/_/e-a-photography.jpg?4',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 10,
      favourites: 72,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/619afafd-a876-4e65-a618-f7286c0d381e/ddltq6o-71373005-7bf0-4019-bc3e-32926c678bbf.jpg',
      prettyName: 'still___esmeralda_belladone_by_e_a_photography_ddltq6o',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9Mzc0NCIsInBhdGgiOiJcL2ZcLzYxOWFmYWZkLWE4NzYtNGU2NS1hNjE4LWY3Mjg2YzBkMzgxZVwvZGRsdHE2by03MTM3MzAwNS03YmYwLTQwMTktYmMzZS0zMjkyNmM2NzhiYmYuanBnIiwid2lkdGgiOiI8PTY1NjQifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.hmrKCuJGmj6162xpKMggg5UUk12aJhaIbG0UUIRdz98',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzYxOWFmYWZkLWE4NzYtNGU2NS1hNjE4LWY3Mjg2YzBkMzgxZVwvZGRsdHE2by03MTM3MzAwNS03YmYwLTQwMTktYmMzZS0zMjkyNmM2NzhiYmYuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.Wg63DTaCfQqzQtNw2uNfZTLKlQhpNNndGlb97lL1s5s',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 86,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_171,q_70,strp/<prettyName>-200h.jpg',
          h: 171,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 171,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_438,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 438,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_614,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 614,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_701,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 701,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1184,h_675,q_70,strp/<prettyName>-pre.jpg',
          h: 675,
          w: 1184,
          f: 20501375,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1184,h_675,q_70,strp/<prettyName>-pre.jpg',
          h: 675,
          w: 1184,
        },
        {
          t: 'fullview',
          r: 1,
          h: 3744,
          w: 6564,
          f: 20501375,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/822719184/">Still - Esmeralda Belladone</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/e-a-photography" target="_self">E-A-photography</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-05T00:00:00-0800',
      giver: {
        userId: 11058281,
        useridUuid: 'ccb995b7-6baa-4ebe-a468-3b0452ebedf5',
        username: 'ElyneNoir',
        usericon: 'https://a.deviantart.net/avatars-big/e/l/elynenoir.gif',
        type: 'volunteer',
        isNewDeviant: false,
      },
      suggester: {
        userId: 50965902,
        useridUuid: '49074e25-c37c-447d-b0d2-60553c4a0495',
        username: 'Cicunni',
        usericon: 'https://a.deviantart.net/avatars-big/c/i/cicunni.jpg?5',
        type: 'regular',
        isNewDeviant: true,
      },
    },
  },
  {
    deviationId: 812224029,
    typeId: 1,
    url: 'https://www.deviantart.com/saartha/art/Bloom-812224029',
    title: 'Bloom',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-09-05T08:39:17-0700',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/812224029',
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 2857352,
      useridUuid: 'e32ada23-9fc5-4df8-a415-561f4d28feb6',
      username: 'saartha',
      usericon: 'https://a.deviantart.net/avatars-big/s/a/saartha.gif?2',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 46,
      favourites: 56,
    },
    media: {
      types: [
        {
          t: 'preview',
          r: -2,
          s: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          h: 220,
          w: 500,
        },
      ],
    },
    dailyDeviation: {
      body: '<a href="https://www.deviantart.com/deviation/812224029/">Bloom</a> by <span class="username-with-symbol u"><a class="u regular username" href="https://www.deviantart.com/saartha" target="_self">saartha</a><span class="user-symbol regular" data-quicktip-text="" data-show-tooltip="" data-gruser-type="regular"></span></span>',
      time: '2020-01-05T00:00:00-0800',
      giver: {
        userId: 1837909,
        useridUuid: 'd3a4dd2c-2d10-4d5f-b48d-2cdbb7b831f6',
        username: 'JessaMar',
        usericon: 'https://a.deviantart.net/avatars-big/j/e/jessamar.jpg?8',
        type: 'volunteer',
        isNewDeviant: false,
      },
    },
    textContent: {
      excerpt:
        "Morning ferrets out\nthe shadows from under\nthe trees. It seems\nthe whole world is one\nunending field of\nQueen Anne's lace.\n\nIt's okay. I know, one day\nthe flowers will grow over\nme, too\n\nand all the molecules of me\nlose their stubborn affections\nbecome lichen, beetle wing,\nfragrant bark.\n\nFor now September settles\nwarm and soft as a hen,\nthe dew turns it all\na rosy gold. My heart twists\nand aches so gently,\nso sweetly, it must surely\nbloom from it.",
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
];
